import { render, staticRenderFns } from "./ResetUserBusinessPassword.vue?vue&type=template&id=1b20b366&"
import script from "./ResetUserBusinessPassword.ts?vue&type=script&lang=ts&"
export * from "./ResetUserBusinessPassword.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports